import script from "./GuideTaskPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideTaskPage.vue?vue&type=script&setup=true&lang=ts"

import "./GuideTaskPage.vue?vue&type=style&index=0&id=d542dd72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d542dd72"]])

export default __exports__